// extracted by mini-css-extract-plugin
export default {"DeleteClientAdminDialog":"DeleteClientAdminDialog_DeleteClientAdminDialog__Jh7-K"};